var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-normal',{attrs:{"title":"Sms Kredi Bilgileri"},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('div',[_vm._v("sdds")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }